import { FC } from 'react';
import { Nav } from 'react-bootstrap';

interface MenuItemProps {
  title: string;
  to: string;
}

const MenuItem: FC<MenuItemProps> = ({ title, to }) => {
  return <Nav.Link eventKey={to}>{title}</Nav.Link>;
};

export default MenuItem;
